import en from './locales/en.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';
import kok from './locales/kok.json';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'ta', label: 'Tamil', nativeLabel: 'தமிழ்' },
  { code: 'kok', label: 'Konkani', nativeLabel: 'कोंकणी' },
] as const;

export type LocaleCode = (typeof SUPPORTED_LOCALES)[number]['code'];

/** i18next resources. English is the fallback; partial translations fall back key-by-key. */
export const resources = {
  en: { translation: en },
  hi: { translation: hi },
  ta: { translation: ta },
  kok: { translation: kok },
} as const;

export type TranslationShape = typeof en;

export function normalizeLocale(input: string | null | undefined): LocaleCode {
  const base = (input ?? 'en').toLowerCase().split(/[-_]/)[0];
  return (SUPPORTED_LOCALES.find((l) => l.code === base)?.code ?? 'en') as LocaleCode;
}
